/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M8.25 1.5c1.2426 0 2.25 1.0074 2.25 2.25v4.5c0 1.2426-1.0074 2.25-2.25 2.25h-6C1.0074 10.5 0 9.4926 0 8.25v-4.5C0 2.5074 1.0074 1.5 2.25 1.5h6Zm-6 1.5a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 .75.75h6A.75.75 0 0 0 9 8.25v-4.5A.75.75 0 0 0 8.25 3h-6Zm6 10.5c1.2426 0 2.25 1.0074 2.25 2.25v4.5c0 1.2426-1.0074 2.25-2.25 2.25h-6C1.0074 22.5 0 21.4926 0 20.25v-4.5c0-1.2426 1.0074-2.25 2.25-2.25h6Zm-6 1.5a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 .75.75h6a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75h-6ZM13.5 3.75c0-1.2426 1.0074-2.25 2.25-2.25h6C22.9926 1.5 24 2.5074 24 3.75v4.5c0 1.2426-1.0074 2.25-2.25 2.25h-6c-1.2426 0-2.25-1.0074-2.25-2.25v-4.5ZM15.75 3a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 .75.75h6a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75h-6Zm6 10.5c1.2426 0 2.25 1.0074 2.25 2.25v4.5c0 1.2426-1.0074 2.25-2.25 2.25h-6c-1.2426 0-2.25-1.0074-2.25-2.25v-4.5c0-1.2426 1.0074-2.25 2.25-2.25h6Zm-6 1.5a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 .75.75h6a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75h-6Z"
    clipRule="evenodd"
  />,
  'Plates'
);
